// add needed core-js polyfills
import 'js-polyfills/dom';
import 'js-polyfills/html';
import 'core-js/es6/array';
// import 'core-js/es6/object';
import 'core-js/es7/object';
import 'classlist-polyfill';
import objectFitImages from 'object-fit-images';
import 'svgxuse';
import 'flickity';

import './utils/init';

import './components/drawing';
import './components/img-loader';
import './components/search';
import './components/select';
import './components/carousel';
import './components/click-effect';
import './components/range';
import './components/header';
import './components/lightbox';
import './components/tab';
import './components/img-switch';
import './components/clear-input';
import './components/search-faq';
import './components/option-changer';
import './components/silent-scroll-to';
import './components/form-redirect';
import './components/news';
import './components/accessibility';
import './components/iframe-ratio';
import './components/menu';
import './components/premise';
import './components/input';
import './components/form-contact';
import './components/form-error';
import './components/form-availability';
import './components/form-budget';
import './components/form-budget-vote';
import './components/form-sposor-application';
import './components/form-student-application';
import './components/form-thoughts-application';
import './components/form-job-subscribe';
import './components/form-premise-subscribe';
import './components/form-premise-unsubscribe';
import './components/translation';
import './components/menu-mobile';
import './components/menu-left';
import './components/notice';
import './components/map';
import './components/accordion';
import './components/project';
import './components/projectsPage';
import './components/welcome';
import './components/form-part';
import './components/social-feed';
import './components/analytics';

objectFitImages('img');
